<template>
    <v-container class="row-padding" grid-list-xl fluid>
        <v-expansion-panels focusable hover inset>
            <!--SPEECH DETAILS-->
            <v-expansion-panel class="mb-2">
                <v-expansion-panel-header class="pa-0" style="min-height:0" hide-actions>
                    <v-toolbar class="expand-panel-header-custom" dense dark>
                        <v-app-bar-nav-icon></v-app-bar-nav-icon>

                        <v-toolbar-title>Datos del discurso</v-toolbar-title>

                        <v-spacer></v-spacer>

                        <v-btn icon>
                            <v-icon>mdi-information</v-icon>
                        </v-btn>
                    </v-toolbar>
                </v-expansion-panel-header>

                <v-expansion-panel-content class="filter-color pt-4">

                    <v-card id="info-card" class="item-card mx-auto pa-5" raised elevation="100">

                        <loading-wheel v-if="!speech"></loading-wheel>
                        <v-card outlined class="filter-row-color my-3">
                            <v-container v-if="speech" class="pa-5" grid-list-xl fluid>
                                <v-row no-gutters>
                                    <v-col cols="auto">
                                        <v-text-field label="Código" color="#da8d2b" style="max-width:90px"
                                            v-model="speech['cod']" hide-details="true" type="label" readonly fill>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                        <v-card outlined class="filter-row-color my-3">
                            <v-container v-if="speech" class="pa-5" fluid>
                                <v-row no-gutters class="">
                                    <v-col cols="12">
                                        <v-row no-gutters justify="start" align="center">
                                            <v-text-field class="my-3 mr-10" style="max-width:80px" label="Orden"
                                                color="#da8d2b" v-model="speech['order']" hide-details="true"
                                                type="label" readonly fill>
                                            </v-text-field>
                                        </v-row>
                                        <v-row no-gutters justify="start" align="center">
                                            <v-text-field class="my-3 mr-10" style="max-width:105px" label="Inicio"
                                                color="#da8d2b" v-model="speech['start']" hide-details="true"
                                                type="label" readonly fill>
                                                <template v-slot:append>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon dense v-on="on">mdi-ray-start-arrow</v-icon>
                                                        </template>
                                                        "Tiempo de inicio del discurso."
                                                    </v-tooltip>
                                                </template>
                                            </v-text-field>
                                            <v-text-field class="my-3 mr-10" style="max-width:95px" label="Finalización"
                                                color="#da8d2b" v-model="speech['end']" hide-details="true" type="label"
                                                readonly fill>
                                                <template v-slot:append>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon dense v-on="on">mdi-ray-end-arrow</v-icon>
                                                        </template>
                                                        "Tiempo de finalización del discurso."
                                                    </v-tooltip>
                                                </template>
                                            </v-text-field>
                                            <v-text-field class="my-3 mr-5" style="max-width:100px" label="Duración"
                                                color="#da8d2b" v-model="speech['duration']" hide-details="true"
                                                type="label" readonly fill>
                                                <template v-slot:append>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon dense v-on="on">mdi-clock</v-icon>
                                                        </template>
                                                        "Tiempo de duración del discurso."
                                                    </v-tooltip>
                                                </template>
                                            </v-text-field>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                        <v-card outlined class="filter-row-color my-3">
                            <v-container v-if="speech" class="pa-5" fluid>
                                <v-row no-gutters class="">
                                    <v-col cols="12">
                                        <v-row no-gutters justify="start" align="center" height="300">
                                            <v-textarea label="Contenido" color="#da8d2b" hide-details="true" auto-grow
                                                v-html="speech['metadata_contents']" readonly fill></v-textarea>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>

        </v-expansion-panels>
        <v-card class="discursive-units-card">
            <v-card-title class="discursive-units-card-title">
                Exploración por unidades discursivas
            </v-card-title>
            <v-expansion-panels focusable hover inset>
                <!--DIALOGUES-->
                <v-expansion-panel class="mb-2">
                    <v-expansion-panel-header class="pa-0" style="min-height:0" hide-actions>
                        <v-toolbar class="expand-panel-header-custom" dense dark>
                            <v-app-bar-nav-icon></v-app-bar-nav-icon>

                            <v-toolbar-title>Diálogos</v-toolbar-title>

                            <v-spacer></v-spacer>

                            <v-btn icon>
                                <v-icon>mdi-library-books</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content class="filter-color pt-4">

                        <v-card class="item-card mx-auto" raised elevation="100">

                            <v-container class="filter-row-color pa-5" fluid>
                                <v-row no-gutters class="">
                                    <v-col cols="12">
                                        <v-data-table class="transparent" show-expand single-expand item-key="cod"
                                            :headers="headers" :items="dialogs" :expanded.sync="expanded"
                                            @item-expanded="loadDialogueDetails" @update="alert('')" locale="es-ES"
                                            :search="search" :custom-filter="searchFilter" :loading="dialogs_loading"
                                            loading-text="Cargando datos..."
                                            no-data-text="No se han encontrado resultados" :footer-props="{
                                                itemsPerPageOptions: [10, 20, 30],
                                                'items-per-page-text': 'Diálogos por página'
                                            }">

                                            <template v-slot:top>
                                                <v-container grid-list-xl fluid>
                                                    <v-layout row wrap>
                                                        <v-flex class="row-padding" xs12>
                                                            <v-row no-gutters justify="end">
                                                                <v-col cols="auto">
                                                                    <v-text-field class="mx-4 my-3"
                                                                        style="max-width:300px" v-model="search"
                                                                        append-icon="search" label="Filtrar" dense>
                                                                    </v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </template>

                                            <template v-slot:item="{ item, index, expand, isExpanded }">
                                                <tr :id="'row_' + item['cod']" :key="item.cod">
                                                    <td class="text-xs-left">
                                                        <v-btn small text icon @click="expand(!isExpanded)">
                                                            <v-icon color="primary"
                                                                v-if="isExpanded">mdi-chevron-down</v-icon>
                                                            <v-icon color="orange" v-else>mdi-chevron-right</v-icon>
                                                        </v-btn>
                                                    </td>
                                                    <!--                                                <td class="text-left body-1">
                                                                                                    {{item["cod"]}}
                                                                                                </td>-->
                                                    <td>
                                                        <v-text-field class="discursive-unit-content text-start"
                                                            type="string" dense hide-details
                                                            v-html="item.metadata_contents">
                                                        </v-text-field>
                                                    </td>
                                                    <td class="text-center body-1">
                                                        {{ item.duration }}
                                                    </td>
                                                </tr>
                                            </template>

                                            <template v-slot:expanded-item="{ headers, item }">
                                                <td :colspan="headers.length" style="padding:0">
                                                    <v-card v-if="item" class="filter-color" text tile>
                                                        <v-container v-if="speech" class="px-5 py-3" fluid>
                                                            <v-row no-gutters>
                                                                <v-col cols="12">
                                                                    <v-row no-gutters justify="start" align="center">
                                                                        <!--                                                                    <v-text-field
                                                                                                                                            class="my-3 mr-10"
                                                                                                                                            style="max-width:105px"
                                                                                                                                            label="Intervenciones"
                                                                                                                                            color="#da8d2b"
                                                                                                                                            v-model="expanded[0]['interventions_count']"
                                                                                                                                            hide-details="true"
                                                                                                                                            type="label"
                                                                                                                                            readonly
                                                                                                                                            fill
                                                                                                                                            >
                                                                                                                                            <template v-slot:append>
                                                                                                                                                <v-tooltip
                                                                                                                                                    bottom
                                                                                                                                                    >
                                                                                                                                                    <template v-slot:activator="{ on }">
                                                                                                                                                        <v-icon v-on="on">record_voice_over</v-icon>
                                                                                                                                                    </template>
                                    "Número de intervenciones dentro del diálogo."
                                    </v-tooltip>
                                    </template>
                                    </v-text-field>
                                    <v-text-field class="my-3 mr-10" style="max-width:80px" label="Palabras"
                                        color="#da8d2b" v-model="expanded[0]['tokens_count']" hide-details="true"
                                        type="label" readonly fill>
                                        <template v-slot:append>
                                                                                                                                                <v-tooltip
                                                                                                                                                    bottom
                                                                                                                                                    >
                                                                                                                                                    <template v-slot:activator="{ on }">
                                                                                                                                                        <v-icon v-on="on">font_download</v-icon>
                                                                                                                                                    </template>
                                        "Número de palabras en el diálogo."
                                        </v-tooltip>
                                        </template>
                                    </v-text-field>-->
                                                                        <loading-wheel
                                                                            v-if="audio_is_loading"></loading-wheel>
                                                                        <div :id="'plyr_dialogue_' + item['cod']">
                                                                            <audio id="audio_player">
                                                                            </audio>
                                                                        </div>
                                                                    </v-row>
                                                                    <v-row no-gutters justify="center" align="center">
                                                                        <v-btn class="ml-10" rounded dense
                                                                            :to="getItemLink('dialog_details', item['cod'])"
                                                                            dark>
                                                                            <!-- @click.stop="openDetailedView('dialog_details', item['cod'])" -->
                                                                            <v-icon dark>pageview</v-icon>
                                                                            <span style="text-indent: 5px">Ver
                                                                                Detalles</span>
                                                                        </v-btn>
                                                                    </v-row>
                                                                </v-col>
                                                            </v-row>
                                                        </v-container>
                                                    </v-card>
                                                </td>
                                            </template>

                                            <template v-slot:[`footer.page-text`]="items"> {{ items.pageStart }} - {{
                                                items.pageStop }} de {{ items.itemsLength }} </template>
                                        </v-data-table>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>
    </v-container>
</template>
<script>
import api from '@/restApi';
import { Breadcrumb, Loading } from '@/components';

export default {
    name: 'speech-details',
    bodyClass: 'default-page',
    props: {
        code: {
            type: String,
            default() {
                return "";
            }
        }
    },
    data() {
        return {
            page: null,
            section: null,
            subsection: null,
            search: "",
            player: null,
            conversation: null,
            speech: null,
            dialogs: [],
            alternate: false,
            audio_is_loading: true,
            expanded: [],
            headers: [
                //                    {
                //                        text: "Id",
                //                        align: "left",
                //                        sortable: "false",
                //                        value: "cod"
                //                    },
                {
                    text: "Contenido",
                    align: "center",
                    value: "contents"
                },
                {
                    text: "Duración",
                    align: "center",
                    value: "duration",
                    width: 100
                }
            ],
            dialogs_loading: true
        };
    },
    created: function () {
        const params = this.$route.params;

        this.page = params.page;
        this.section = params.section;
        this.subsection = params.subsection;

        this.loadSpeechData();
    },
    mounted: function () {
    },
    watch: {
    },
    methods: {
        getItemLink(view, cod) {
            const link = '/pages/' + this.page + "/" + this.section + "/" + this.subsection + "/" + view + "/" + cod;

            return link;
        },
        searchFilter(value, search, item) {
            //                console.log(value + " - " + search + " - " + item);

            return (value !== null &&
                search !== null && typeof value === 'string' &&
                this.$mout.string.contains(item.metadata_contents, search));
        },
        async loadDialogueDetails({ item }) {
            var elementId, conversationCode;
            var start, duration;
            var isExpanding;
            var self = this;

            self.audio_is_loading = true;

            self.alternate = !self.alternate;

            isExpanding = !this.$mout.array.filter(self.expanded, function (item2) {
                //                console.log(item2["cod"],"-",item["cod"])
                return item2["cod"] === item["cod"];
            }).length > 0;


            if (this.$mout.lang.isEmpty(item) || !isExpanding) {
                return;
            }

            //                console.log("Element", "plyr_speech_" + item["cod"]);
            //                console.log("Expanded item", item);

            elementId = "#audio_player";
            conversationCode = item["cod"].substring(0, item["cod"].indexOf("-"));
            start = item["start"];
            duration = item["end"] - item["start"];

            if (self.player) {
                self.player.destroy();
            }

            setTimeout(async function () {
                self.player = await self.loadPlayer(elementId, conversationCode, start, duration, self.audio_is_loading);

                self.audio_is_loading = false;
            }, 10);
        },
        openDetailedView(view, inputParams, modifiers) {
            this.$emit('clicked', view + (inputParams ? "/" + inputParams : "") + "/" + (modifiers ? "/" + inputParams : ""));
        },
        async loadSpeechData() {
            await this.loadSpeech();
            this.loadConversation();
            this.loadDialogs(this.speech["_id"]);
        },
        async loadSpeech() {
            var speechContents;

            const queryString = "cod=" + this.code + "&fields=cod,contents_preview,start,end&sort={\"field\":\"order\",\"dir\":\"asc\"}";

            // Get the speech with given code
            const response = await api.get("speech", queryString);

            if (response instanceof Error) {
                // Do not continue
                return;
            }

            const speeches = response;
            
            if (speeches.length <= 0) {
                return;
            }

            this.speech = speeches[0];


            //                this.speech["tokens_count"] = await api.getTokenCount(this.speech["cod"]);
            //                this.speech["dialogs_count"] = await api.getInterventionCount(this.speech["cod"]);

            this.speech["duration"] = this.millisToMinutesAndSeconds(this.speech["end"] - this.speech["start"]);
            this.speech["start"] = this.millisToMinutesAndSeconds(this.speech["start"]);
            this.speech["end"] = this.millisToMinutesAndSeconds(this.speech["end"]);

            speechContents = this.speech["contents_preview"];

            this.speech["metadata_contents"] = "";
            if (!this.$mout.lang.isEmpty(speechContents)) {
                this.speech["metadata_contents"] = speechContents;
            }
        },
        async loadConversation() {
            var conversationCode;

            conversationCode = this.speech["cod"].substring(0, this.speech["cod"].indexOf("-"));

            //                console.log("Conversation code:", conversationCode);

            const queryString = "cod=" + conversationCode + "&fields=cod,duration";

            // Get conversation by code
            const response = await api.getAllItems("conversation", queryString);

            if (response instanceof Error) {
                // Do not continue
                return;
            }

            const conversations = response;

            if (conversations.length <= 0) {
                return;
            }

            this.conversation = conversations[0];
        },
        async loadDialogs(speechId) {

            this.dialogs_loading = true;

            const queryString = "speech=" + speechId + "&fields=cod,contents_preview,start,end&sort={\"field\":\"order\",\"dir\":\"asc\"}";

            // Get all dialogs
            const response = await api.getAllItems("dialog", queryString);

            if (response instanceof Error) {
                // Do not continue
                return;
            }

            const dialogs = response;

            for (var dialog of dialogs) {
                dialog["metadata_contents"] = dialog["contents_preview"];
                dialog["duration"] = this.millisToMinutesAndSeconds(dialog["end"] - dialog["start"]);
            }

            this.dialogs = dialogs;

            this.dialogs_loading = false;
        }
    },
    components: {
        [Breadcrumb.name]: Breadcrumb,
        [Loading.name]: Loading
    }
};
</script>

<style>
.transparent>.table,
.transparent>.table__overflow>.table,
.transparent>.table>.datatable__actions {
    background-color: #fde19a;
}
</style>
